import { createSelector } from "reselect";

const selectQuizathon = (state) => state.quizathons;

export const quizathonListLoading = createSelector(
  [selectQuizathon],
  (quizathon) => quizathon.isLoading
);

export const selectQuizathonList = createSelector(
  [selectQuizathon],
  (quizathon) => quizathon.quizathonList
);

export const selectIsCreatingQuizathon = createSelector(
  [selectQuizathon],
  (quizathon) =>  quizathon.isCreatingQuizathon
);
export const selectIsEditingQuizathon = createSelector(
  [selectQuizathon],
  (quizathon) =>  quizathon.isEditingQuizathon
);

export const selectQuizathonParticipants = createSelector(
  [selectQuizathon],
  (quizathon) => quizathon.participants
);

export const selectIsLoadingQuizathonParticipants = createSelector(
  [selectQuizathon],
  (quizathon) => quizathon.isLoadingParticipants
);
export const selectSingleQuizathon = createSelector(
  [selectQuizathon],
  (quizathon) => quizathon.singleQuizathon
);

export const selectIsLoadingSingleQuizathon = createSelector(
  [selectQuizathon],
  (quizathon) => quizathon.isLoadingSingleQuizathon
);
export const selectSingleParticipant = createSelector(
  [selectQuizathon],
  (quizathon) => quizathon.singleParticipant
);

export const selectIsLoadingSingleParticipant = createSelector(
  [selectQuizathon],
  (quizathon) => quizathon.isLoadingSingleParticipant
);
export const selectParticipantLeaderboard = createSelector(
  [selectQuizathon],
  (quizathon) => quizathon.participantLeaderBoard
);

export const selectIsLoadingParticipantLeaderboard = createSelector(
  [selectQuizathon],
  (quizathon) => quizathon.isLoadingParticipantLeaderBoard
);